import styles from './Notification.module.css';
import coin from '../../assets/icons/coin.svg'
import xIcon from '../../assets/icons/x.svg'
import Confetti from 'react-confetti'
import { GeneralObject } from "../../types/General";
import Pill from '../peel/Pill';
import { useRef } from 'react';
import { createPortal } from 'react-dom';

export enum Mode {
    Success = 'green',
    Warning = 'gold',
    Error = 'red'
}

export type CustomNotification = {
    content: string;
    id?: string;
    withoutDismissButton?: boolean;
    dismissButtonContent?: string;
    approveButtonContent?: string;
    onDismissButtonClicked?: () => void;
    onApproveButtonClicked?: () => void;
    type: Mode;
    timeout?: number;
    confetti?: boolean;
}

type NotificationContainerProps = {
    notifications: GeneralObject<CustomNotification>,
    onDismiss: (id: string) => void;
}

function NotificationContainer({ notifications, onDismiss }: NotificationContainerProps) {
    const audioPlayerRef = useRef(new Audio('/coin.mp3'));

    return (
        <div 
            className={styles.container} 
            style={{ transform: Object.values(notifications).length > 0 ? 'scaleY(1)' : 'scaleY(0)' }}
        >
            {Object.values(notifications).map((notification, index) => { 
                if (notification.confetti)
                    audioPlayerRef.current.play();

                return <>
                    {!notification.confetti && 
                    <div key={index} className={styles.item} style={{ backgroundColor: notification.type }}>
                        <div className={styles.btncontainer}>
                            {!notification.dismissButtonContent &&
                            <img src={xIcon} height={10} width={10} onClick={() => onDismiss(notification.id || 'temp')}/>}

                            {notification.dismissButtonContent && 
                            <Pill 
                                className={styles.btn}
                                label={notification.dismissButtonContent} 
                                onClick={notification.onDismissButtonClicked}
                            />}
            
                            {notification.approveButtonContent && 
                            <Pill 
                                selected 
                                className={styles.btn}    
                                label={notification.approveButtonContent} 
                                onClick={notification.onApproveButtonClicked}
                            />}
                        </div>

                        {notification.content}

                        <div/>
                    </div>}    

                    {notification.confetti && createPortal(
                        <>
                            <img src={coin} className={styles.flippingcoin}/>
                            <Confetti style={{ zIndex: 100 }} gravity={0.2}/>
                        </>
                    , document.getElementById('portal') as HTMLElement)}
                </>
                }
            )}
        </div>
    )
}

export default NotificationContainer;